import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { UseSupportedBrowser } from "@/hooks/index";
import {
  compareDateIsOlder,
  getDataImageFromRelated,
  getDataImageSelectedFromRelated,
  getDataVideoFromRelated,
  getImageByClippings,
  getStringWithoutHtml,
  nsSite,
} from "helpers";
import { getClippingsByTypeNews } from "../../Nota/helpers";
import { sizeBanner } from "@/shared/DFP/News/mapping";
import { BannerCollapse } from "@/shared/ContentBanner";
import { menu } from "@/shared/Footer/data";
import { print } from "../helper/print";

export const useRecipeNews = (props) => {
  const { content, ...rest } = props;

  let querySectionId, keySection;
  querySectionId = content?.sections?.[0]?._id;
  keySection = "sections";
  let adsPath = content?.sections?.[0]?.metadata?.adsPath || "recetas";
  if (!!content?.mainSectionTree) {
    querySectionId = content.mainSectionTree?.[0]?._id;
    keySection = "mainSectionTree";
    adsPath = content?.mainSectionTree?.[0]?.metadata?.adsPath || "recetas"; 
  }
  const latestRigthColumnSectionID = !!content?.[keySection]?.[0]?.metadata
    ?.latestRigthColumn
    ? querySectionId
    : false;
  const mostSeenSuscriptionSectionID = !!content?.[keySection]?.[0]?.metadata
    ?.mostSeenSuscription
    ? querySectionId
    : false;

  const [latestRigthColumn, setLatestRigthColumn] = useState([]);
  const [mostSeenSuscription, setMostSeenSuscription] = useState([]);
  const [newsToday, setNewsToday] = useState([]);
  const [latestSection, setLatestSection] = useState([]);
  const [showRewarded, setShowRewarded] = useState(false);
  const [innerWidth, setInnerWidth] = useState(0);
  const [countComments, setCountComments] = useState(0);
  const [currentImageSlide, setCurrentImageSlide] = useState(null);
  const router = useRouter();

  const dataImageRelated = getDataImageFromRelated(content?.related);
  const dataImageHeader = getImageByClippings(
    getClippingsByTypeNews("normal"),
    dataImageRelated.clippings
  );
  dataImageHeader.epigraphe = dataImageRelated.epigraphe;

  const dataImageManualCrop = getDataImageSelectedFromRelated(content?.related);
  if (dataImageManualCrop.image && dataImageManualCrop.image !== "#") {
    dataImageHeader.desktop = dataImageManualCrop;
    dataImageHeader.mobile = dataImageManualCrop;
  }
  const dataImageShare = getImageByClippings(
    { default: ["share"], mobile: ["share"] },
    dataImageRelated.clippings
  );
  const dataVideoHeader = getDataVideoFromRelated(content?.related);
  const sectionNameAds = content?.sections?.[0]?.name
    ?.replace(/[\s-]+/g, "-") 
    .toLowerCase();

  const sectionUrl = content?.sections?.[0]?.url;

  const sectionName = content?.sections?.[0]?.metadata?.section
  ? content?.sections?.[0]?.metadata?.section
  : content?.sections?.[0]?.name
  ? content?.sections?.[0]?.name
  : "";

  const sectionData = {
    name: sectionName,
    url: sectionUrl
  };
  const parseSummary = getStringWithoutHtml(content?.summary);
  const newsSeo = content?.related?.lilanewsSeo ?? [];
  const relatedNews = content?.related?.lilanews ?? [];
  let relatedVideosLoop = content?.related?.videosOpenLoop?.[0]?.value ?? "";
  const hasRelated =
    content?.freeHtml == null &&
    dataImageHeader.desktop.image == "#" &&
    dataVideoHeader == null
      ? false
      : true;
  const titleEnableFreeHtml = !(
    content?.freeHtml && !content?.metadata.titleEnable
  );
  const featuresBody = content?.features
    ? { type: "featuresRecipe", value: { ...content?.features } }
    : null;

  const dataAnalitics = {
    asPath: router.asPath,
    name: `noticias.${content?.gtm_name}`,
    newsType: "default",
    notaId: content?._id,
    nsSite: nsSite(content?.sections),
    pageType: "recetas",
    publishedDate: content?.publishedDate ?? new Date(),
    sections: content?.sections,
    summary: parseSummary,
    tags: content?.tags,
  };

  const dataMeter = {
    tags: content?.tags,
    metadata: content?.metadata,
    pageType: "default",
    section: content?.sections?.[0]?.url?.replace(/\//g, ","),
    mainSectionTree: content?.mainSectionTree,
    authors: content?.authors?.[0]?.slug ?? null,
    paywall: content?.metadata?.payWallAccessControl ?? "freemiun",
    typeWeb: "recetas",
    category: "recipe",
  };

  const submenu = rest?.menu?.menurecetas?.item?.items;

  const loadRigthColumn = async () => {
    const fetchMostSeenSuscription = await fetch(
      `/api/viewed/5/${mostSeenSuscriptionSectionID !== false ? "ga4" : "bi"}` +
        `${
          mostSeenSuscriptionSectionID !== false
            ? `?section=${mostSeenSuscriptionSectionID}&sectionType=${content?.type}`
            : ""
        }`
    );
    const dataMostSeenSuscription = await fetchMostSeenSuscription.json();
    setMostSeenSuscription({
      title: "Las recetas más leídas",
      name: "MostSeenSuscription",
      content: dataMostSeenSuscription?.data ?? [],
    });
    const fetchLatestRigthColumn = await fetch(
      `/api/latest/${
        latestRigthColumnSectionID !== false ? content?.type : "lilanews"
      }/5` +
        `${
          latestRigthColumnSectionID !== false
            ? "?section=" + latestRigthColumnSectionID
            : ""
        }`
    );
    const dataLatestRigthColumn = await fetchLatestRigthColumn.json();
    setLatestRigthColumn({
      title: "Últimas recetas",
      name: "LatestRigthColumn",
      content: dataLatestRigthColumn?.data ?? [],
    });
  };
  const loadNewsToday = async () => {
    const fetchNewsToday = await fetch("/api/menus/noticiashoy");
    const dataNewsToday = await fetchNewsToday.json();
    const data =
      dataNewsToday?.data?.items?.length > 0 ? dataNewsToday.data?.items : [];
    setNewsToday(data);
  };
  const loadCountComments = async () => {
    const fetchCountComments = await fetch(
      "/api/viafoura/comments/" + content?._id
    );
    const dataCountComments = await fetchCountComments.json();
    setCountComments(dataCountComments?.data?.total_visible_content ?? 0);
  };
  const loadLatestSection = async () => {
    const fetchLatestSection = await fetch(
      `/api/latest/recipes/4?sectionId=${querySectionId}`
    );
    const dataLatestSection = await fetchLatestSection.json();
    const data =
      dataLatestSection?.data?.length > 0 ? dataLatestSection.data : [];
    setLatestSection(data);
  };

  useEffect(() => {
    if (document) {
      setInnerWidth(document.body.clientWidth);
    }
    if (typeof window.getRewarded == "undefined") {
      window.getRewarded = () => {
        setShowRewarded(true);
      };
    }
    loadRigthColumn();
    loadNewsToday();
    loadCountComments();
    loadLatestSection();
  }, []);

  const rightColumn = [
    { name: "Banner", bannerId: "caja0" },
    latestRigthColumn ?? { name: "" },
    {
      name: "BannerLazy",
      bannerId: "caja1",
      container: BannerCollapse,
      adsPath: "recetas/nota",
      mapping: sizeBanner.caja1,
    },
    mostSeenSuscription ?? { name: "" },
    {
      name: "BannerLazy",
      bannerId: "caja2",
      container: BannerCollapse,
      adsPath: "recetas/nota",
      mapping: sizeBanner.caja2,
    },
    {
      name: "BannerLazy",
      bannerId: "caja3",
      container: BannerCollapse,
      adsPath: "recetas/nota",
      mapping: sizeBanner.caja3,
    },
  ];

  //pasamos de Z a -3
  let publishedDate_AR = new Date(content?.publishedDate);
  publishedDate_AR = new Date(
    publishedDate_AR.toLocaleString("en-US", {
      timeZone: "America/Argentina/Buenos_Aires",
    })
  );
  let modificatedAt_AR = new Date(content?.modificatedAt);
  modificatedAt_AR = new Date(
    modificatedAt_AR.toLocaleString("en-US", {
      timeZone: "America/Argentina/Buenos_Aires",
    })
  );
  const modificatedAtIsOlder = compareDateIsOlder(
    modificatedAt_AR,
    publishedDate_AR
  );

  let addPathAuthor = "recetas/";

  // se agrega firma del autor a el body de la nota para mostrar antes del mira tambien
  const signatureRecipe =
    content?.authors && content?.authors?.length > 0
      ? {
          type: "signatureRecipe",
          value: { ...content?.authors, addPathAuthor },
        }
      : null;
  if (content?.authors && content?.authors?.length > 0) {
    const alreadyInserted = content?.body.some(
      (item) => item.type === signatureRecipe.type
    );
    if (!alreadyInserted) {
      content?.body.splice(content.body.length, 0, signatureRecipe);
    }
  }

  const sectionMetadataTrinity =
    content?.sections?.[0]?.metadata?.trinity === undefined
      ? true
      : content?.sections?.[0]?.metadata?.trinity;

  const newsMetadataTrinity = !content?.metadata?.trinityDisabled
    ? true
    : false;

  const isSupportedBrowser = UseSupportedBrowser();
  const trinityStatus =
    isSupportedBrowser && sectionMetadataTrinity && newsMetadataTrinity
      ? true
      : false;

  const dataImagesBody = content?.body
    .filter(({ type }) => type == "image" || type == "liveblog")
    .map(({ type, value, epigraphe, selectedClipping }) => {
      if (type == "image") {
        return {
          epigraphe: epigraphe,
          clippings: value.clippings,
          selectedClipping: selectedClipping,
        };
      }
      // es liveblog
      let imagesLiveBlog = value?.body
        ?.filter((element) => element.type == "image")
        .map(({ value, epigraphe }) => {
          return {
            epigraphe: epigraphe,
            clippings: value.clippings,
          };
        });
      return imagesLiveBlog;
    })
    .flat();

  const showDialogSlider = (index = 0) => {
    setCurrentImageSlide(index);
  };

  const imageRelatedInclude =
    hasRelated &&
    !content?.freeHtml?.value?.html &&
    !dataVideoHeader &&
    dataImageHeader
      ? true
      : false;

  const idBucketDiscoverNews = !!content?.[keySection]?.[0]?.metadata
    ?.idBucketDiscoverNews
    ? content[keySection][0].metadata.idBucketDiscoverNews
    : "discover-lx";
  const idBucketRecommender = !!content?.[keySection]?.[0]?.metadata
    ?.idBucketRecommender
    ? content[keySection][0].metadata.idBucketRecommender
    : false;

  const printPage = () => {
    print(content?.title, featuresBody, content?.body);
  };

  return {
    ...rest,
    formatContent: {
      ...content,
      currentImageSlide,
      dataAnalitics,
      dataMeter,
      dataImageRelated,
      dataImagesBody,
      isSupportedBrowser,
      imageRelatedInclude,
      idBucketDiscoverNews,
      idBucketRecommender,
      sectionData,
      sectionNameAds,
      setCurrentImageSlide,
      showRewarded,
      submenu,
      printPage,
      sizeBanner,
      storyContainer: {
        data: {
          _id: content?._id,
          authors: content?.authors,
          body: featuresBody?.type
            ? [featuresBody, ...content?.body]
            : content?.body,
          onClickButtonSlider: (index) => showDialogSlider(index),
          canHaveComments: content?.metadata?.canHaveComments,
          countComments,
          commentsStatus: false,
          dataImage: dataImageHeader,
          dataVideo: dataVideoHeader,
          freeHtml: content?.freeHtml,
          hasRelated,
          innerWidth,
          withBodyBanner: false,
          isPreview: rest?.isPreview ?? false,
          modificatedAt: modificatedAtIsOlder
            ? modificatedAt_AR
            : publishedDate_AR,
          newsSeo,
          publishedDate: publishedDate_AR,
          relatedNews,
          relatedVideosLoop,
          sectionName,
          sections: content?.sections,
          socialNetworkingSelect: ["facebook", "twitter", "whatsapp", "share"],
          specialAuthors: content?.specialAuthors,
          subtitle: content?.subtitle,
          summary: parseSummary,
          tags: content?.tags,
          title: `Receta de ${content?.title}`,
          titleEnable: titleEnableFreeHtml,
          url: content?.url,
          widgets: rightColumn,
          payWallAccessControl:
            content?.metadata?.payWallAccessControl == "suscribers-only"
              ? true
              : false,
          adsPath: adsPath ? adsPath + "/nota" : "seccion/nota",
          trinityStatus: false,
          addPathAuthor,
          type: content?.type,
          latestSection,
          titleLatestSection: `Más recetas de ${content?.sections?.[0]?.name?.replace(
            "Recetas - ",
            ""
          )}`,
          componentBannerDistribution: "Recipes",
        },
        type: "normal",
      },
      dataHead: {
        authors: content?.authors,
        dataImageShare: dataImageShare,
        keywords: content?.keywords,
        publishedDate: content?.publishedDate,
        lastModified: modificatedAtIsOlder
          ? content?.modificatedAt
          : content?.publishedDate,
        menu: rest?.menu ?? {},
        related: content?.related,
        relatedNews: relatedNews,
        sectionUrl: sectionData?.url,
        sections: content?.sections,
        subtitle: content?.subtitle,
        title: `Receta de ${content?.title}`,
        body: content?.body,
        url: content?.url,
        type: content?.type,
        features: content?.features,
        summary: parseSummary,
        createdBy: content?.createdBy,
      },
      dataHeader: {
        menu: rest?.menu ?? {},
        sectionData: sectionData,
        isPreview: rest?.isPreview ?? false,
        isNews: true,
        newsToday: newsToday,
        nameIcon: "logoClarin-shrink",
        logoUrlSection: "recetas",
        titleHeader: "Recetas",
        TAGTitleHeader: "h2",
        showLinkRecipes: true,
        menuRecetas: submenu,
        showLiveblog: false,
      },
    },
  };
};
